import { Component } from '@angular/core';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { TranslateModule } from '@ngx-translate/core';
import { StepsComponent } from './steps/steps.component';
import { WorkflowsComponent } from './workflows/workflows.component';

@Component({
  imports: [MatTab, MatTabGroup, StepsComponent, TranslateModule, WorkflowsComponent],
  selector: 'app-workflow-management',
  standalone: true,
  templateUrl: './workflow-management.component.html',
})
export class WorkflowManagementComponent {}
